<template>
	<div style="text-align:right">
      <span>{{index}}</span>
    </div>
</template>
<script>
export default {
  props: ['value', 'index' , 'row'],
  methods: {
    
  },
}
</script>
